/* tslint:disable:variable-name */
import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { DocumentTypeEnterprise } from '../class/DocumentTypeEnterprise';
import { DocumentEntity } from "../class/DocumentEntity";
import { Field } from 'src/app/shared/models/field.model';
import { TemplateFile } from 'src/app/shared/models/template-file.model';
import { DocumentTemplate } from 'src/app/shared/models/document-template.model';
import { FormData } from 'src/app/shared/models/form-data.model';
import { EnumAdjustedContents } from '../constants/contract';
import { Message } from '../class/message';
import { EnumCriteriaCode } from '../constants/criteria-code';

@Injectable({
  providedIn: 'root'
})
export class CreateContractMohaService {
  constructor(
    public message: Message,
  ) {
  }

  public recordsPartySign: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  public recordsUserPerformSign: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  public recordsInternalUsers: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  public pdfSrc: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public fileUpload: BehaviorSubject<File> = new BehaviorSubject<File>(null);
  public selectedTemplate: BehaviorSubject<DocumentTypeEnterprise> = new BehaviorSubject<DocumentTypeEnterprise>(null);
  public document: BehaviorSubject<DocumentEntity> = new BehaviorSubject<DocumentEntity>(null);
  public currentStep: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  public dataReferenceContract: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  public dataDocumentParentNewUploadContractAttachments: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  public isSubmitData: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public isInvalidSetPartyFlow: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public isValidateData: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public isConfirmBCT: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public contractCode: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public isRecordsPartySignValid: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public isGeneralInfoValid: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public createContractType: BehaviorSubject<number> = new BehaviorSubject<number>(null);
  public isOnAutoNumber: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public configAutoNumber: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  public selectedServiceType: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public exampleContractCodeAutoNumber: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  public refreshContractCode: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public isChangeFile: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public isChangeTypeDocAndTemp: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);//doi giua file va mau
  public backView: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  public fieldData: Field[] = null;
  public documentFileTemplate: BehaviorSubject<TemplateFile> = new BehaviorSubject<TemplateFile>(null);
  public documentTemplate: DocumentTemplate = null;

  public isExportData: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public fileExport: File = null;
  public isSuccessStep2: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  public isDuplicateCode: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public isSignatureConfiguration: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
  public tableModel: FormData = null;
  public saveDataTable: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  public cacheRecordParty: any;
  public cacheRecordInternalUser: any;
  public isBack: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public checkFootNote: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public isDirty: boolean = false;
  public isShowPopupPdf: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public changeFileOutput: boolean = false;
  public signatureData: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public listDataCustomerApproveResize: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public signatureDataSign: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public cacheCustomerForSignature: any;
  public saveRecordParty: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public signPositions: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  public contractCodePositions: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  public listSignatureTable: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  public isInvalidInfo: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public codeIsDuplicate = new BehaviorSubject<boolean>(false);
  public isValidForm: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  public isInvalidFieldTypeContract: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public isRenderNewFile: boolean = false;
  public isNewFileTag: boolean = false;
  public procedureId: any;
  public procedureType: any;
  public fileUploadSrc: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  public fileUploadArray: BehaviorSubject<File[]> = new BehaviorSubject<File[]>([]);
  public mainContractAttactment: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  public maxSizeSystem: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  public maxPerMainFile: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  public maxPerAttachFile: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  public biggerThan10MBFileSize: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  public isUpdateDocument : boolean=false;
  public serviceTypes:any[]=null;
  public fileSizeUp: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  public isBuyContract10Mb: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public isBuyContract1Mb: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public configSizeApprove: BehaviorSubject<number> = new BehaviorSubject<number>(null);
  public configPageSign: BehaviorSubject<number> = new BehaviorSubject<number>(null);
  public configNumberPosition: BehaviorSubject<number> = new BehaviorSubject<number>(null);
  public infoFile: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public infoFileTemplate: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public isCopy: boolean = false;
  public key: string = null;
  public signatureResponse = null;
  public currentTotalcapacityMainAttachments: BehaviorSubject<number> = new BehaviorSubject<number>(null);
  public fileFormTemplate: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public pdfSrcForm: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public renderFileOnce: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  public recordsSharePartner: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  public contractTerminations: BehaviorSubject<any> = new BehaviorSubject<any>([]);

  public contractMohaUpdateFields: any[] = null;
  public contractMohaFields: any[] = null;
  public customerMohaId: any = null;
  public saveStep3: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public isSuccessStep3: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public prevStep: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  public employmentContractTerm: BehaviorSubject<any> = new BehaviorSubject<any>('LIMITED');
  public effectiveDate : Date = null;
  public expirationDate : Date = null;
  public firstUpdate : boolean = true;
  public idCustomerDefault : string = null;
  public originalContract: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public adjustedContentSelected: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public enumAdjustedContents = EnumAdjustedContents;
  public errorSignEnterprise : boolean = false;
  public errorSignEnterprise2 : boolean = false;
  public errorSignEnterprise3 : boolean = false;
  public docCode : string = "";
  public docContractType : any;

  public effectiveDateKeep : Date = null;
  public expirationDateKeep : Date = null;
  public updateDateKeep: boolean = true;
  public contractTypeDigital: BehaviorSubject<DocumentTypeEnterprise> = new BehaviorSubject<DocumentTypeEnterprise>(null);
  public listDigitalContractFiles: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);

  setRecordsPartySign(value) {
    this.recordsPartySign.next(value);
  }

  getRecordsPartySign() {
    return this.recordsPartySign.asObservable();
  }

  setContractCode(value) {
    this.contractCode.next(value);
  }

  getContractCode() {
    return this.contractCode.asObservable();
  }

  resetData() {
    this.isInvalidFieldTypeContract.next(false);
    this.currentStep.next(0);
    this.pdfSrc.next(null);
    this.selectedTemplate.next(null);
    this.recordsPartySign.next([]);
    this.recordsInternalUsers.next([]);
    this.recordsUserPerformSign.next([]);
    this.document.next(null);
    this.isSubmitData.next(false);
    this.isValidateData.next(false);
    this.isRecordsPartySignValid.next(false);
    this.isGeneralInfoValid.next(false);
    this.fileUpload.next(null);
    this.createContractType.next(null);
    this.fieldData = null;
    this.documentFileTemplate.next(null);
    this.isExportData.next(false);
    this.fileExport = null;
    this.isSuccessStep2.next(false);
    this.isDuplicateCode.next(false);
    this.documentTemplate = null;
    this.tableModel = null;
    this.saveDataTable.next(false);
    this.cacheRecordParty = null;
    this.cacheRecordInternalUser = null;
    this.changeFileOutput = false;
    this.isDirty = false;
    this.signPositions.next([]);
    this.isInvalidInfo.next(false);
    this.signatureData.next(null);
    this.cacheCustomerForSignature = null;
    this.saveRecordParty.next(false);
    this.isValidForm.next(true);
    // this.isRenderNewFile = false;
    this.isNewFileTag = false;
    this.fileUploadArray.next([]);
    this.mainContractAttactment.next([]);
    this.fileUploadSrc.next([]);
    this.procedureId = null;
    this.procedureType = null;
    this.isCopy = false;
    // this.key = null;
    this.signatureResponse = null;
    this.isSignatureConfiguration.next(null);
    this.isOnAutoNumber.next(false);
    this.refreshContractCode.next(false);
    this.configAutoNumber.next('');
    this.selectedServiceType.next(null);
    this.exampleContractCodeAutoNumber.next('');
    this.contractCodePositions.next([]);
    this.listSignatureTable.next([]);
    this.isChangeTypeDocAndTemp.next(false);
    this.isUpdateDocument=false;
    this.serviceTypes=null;
    this.maxSizeSystem.next(0);
    this.maxPerMainFile.next(0);
    this.maxPerAttachFile.next(0);
    this.biggerThan10MBFileSize.next(null);
    this.fileSizeUp.next(null);
    this.isBuyContract10Mb.next(false);
    this.isBuyContract1Mb.next(false);
    this.configSizeApprove.next(null);
    this.configPageSign.next(null);
    this.configNumberPosition.next(null);
    this.infoFile.next(null);
    this.infoFileTemplate.next(null)
    this.fileFormTemplate.next(null)
    this.pdfSrcForm.next(null)
    this.renderFileOnce.next(0)
    this.recordsSharePartner.next([])
    this.contractTerminations.next([])
    this.saveStep3.next(false)
    this.isSuccessStep3.next(false)
    this.originalContract.next('')
    this.contractMohaFields = []
    this.contractMohaUpdateFields = []
    this.customerMohaId = null
    this.effectiveDate = null;
    this.expirationDate = null;
    this.firstUpdate=true;
    this.idCustomerDefault = null;
    this.effectiveDateKeep = null;
    this.expirationDateKeep = null;
    this.updateDateKeep = true;
    this.adjustedContentSelected.next(null);
    this.errorSignEnterprise = false;
    this.errorSignEnterprise2 = false;
    this.errorSignEnterprise3 = false;
    this.adjustedContentSelected.next(null);
    this.docCode = '';
    //this.contractTypeDigital.next(null);
  }

  public validateErrorSetUser(model?) {
    // khi chủ thể không có chủ thể đang đăng nhập thì không kiểm tra user nữa
    const checkCurrentEnterprise = this.recordsPartySign.value.filter(item => item.isCreatedSide === true);
    if (checkCurrentEnterprise.length === 0) {
      // this.isValidNoUserExist = false;
      // this.subscribeIsValidNoUserExist.next(false);
      return false;
    }

    // Kiểm tra trong list ko chua User nào?null
    if (this.recordsUserPerformSign.getValue().length === 0) {
      // this.isValidNoUserExist = true;
      // this.subscribeIsValidNoUserExist.next(true);
      return true;
    } else {
      // this.isValidNoUserExist = false;
      // this.subscribeIsValidNoUserExist.next(false);
    }
    return false;
  }

  validateData() {
    // validate document
    // ds chủ thể
    // ds người dùng
    this.isSubmitData.next(true);
  }

  exportFile() {
    if (!this.isExportData.getValue()) {
      this.isExportData.next(true);
    }
  }

  generateUUID() { // Public Domain/MIT
    let d = new Date().getTime();//Timestamp
    let d2 = ((typeof performance !== 'undefined') && performance.now && (performance.now()*1000)) || 0;//Time in microseconds since page-load or 0 if unsupported
    return 'xxxxxxxx_xxxx_4xxx_yxxx_xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        let r = Math.random() * 16;//random number between 0 and 16
        if(d > 0){//Use timestamp until depleted
            r = (d + r)%16 | 0;
            d = Math.floor(d/16);
        } else {//Use microseconds since page-load if supported
            r = (d2 + r)%16 | 0;
            d2 = Math.floor(d2/16);
        }
        return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
  }

  checkHasOneCustomerType10000(){
    let isHasOne = false
    let recordsPartySign = this.recordsPartySign.getValue();
    if(recordsPartySign && Array.isArray(recordsPartySign) && recordsPartySign.length){
      for(let i = 0 ; i < recordsPartySign.length; i++){
        if(recordsPartySign[i].customerType == 10000){
          isHasOne = true;
          break;
        }
      }
    }
    return isHasOne
  }

  toDateOnly(date: any): Date {
    const d = new Date(date);
    return new Date(d.getFullYear(), d.getMonth(), d.getDate());
  }

  getErrorMessageStep3(){
    if(this.contractMohaFields && this.contractMohaFields.length){
      let nndh_bat_dau = this.getValueByCode(EnumCriteriaCode.nndh_bat_dau)
      let nndh_ket_thuc = this.getValueByCode(EnumCriteriaCode.nndh_ket_thuc)

      let ngay_bat_dau_hdld = this.getValueByCode(EnumCriteriaCode.ngay_bat_dau_hdld)
      let ngay_ket_thuc_hdld = this.getValueByCode(EnumCriteriaCode.ngay_ket_thuc_hdld)

      let thoi_gian_bat_dau_dong_bhxh = this.getValueByCode(EnumCriteriaCode.thoi_gian_bat_dau_dong_bhxh)
      let thoi_gian_ket_thuc_dong_bhxh = this.getValueByCode(EnumCriteriaCode.thoi_gian_ket_thuc_dong_bhxh)

      let nld_ngay_sinh = this.getValueByCode(EnumCriteriaCode.nld_ngay_sinh)

      if(nndh_bat_dau && nndh_ket_thuc &&
        this.toDateOnly(nndh_bat_dau) > this.toDateOnly(nndh_ket_thuc))
      {
        return 'add_document_moha.hazardous_job_start_date_must_be_before_end_date'
      }

      if(ngay_bat_dau_hdld && ngay_ket_thuc_hdld &&
        this.toDateOnly(ngay_bat_dau_hdld) > this.toDateOnly(ngay_ket_thuc_hdld))
      {
        return 'add_document_moha.expiration_date_must_be_on_or_after_effective_date'
      }

      if(ngay_bat_dau_hdld && nld_ngay_sinh &&
        this.toDateOnly(ngay_bat_dau_hdld) <= this.toDateOnly(nld_ngay_sinh))
      {
        return 'add_document_moha.contract_start_date_must_be_after_birth_date'
      }

      if(thoi_gian_bat_dau_dong_bhxh && thoi_gian_ket_thuc_dong_bhxh &&
        new Date(thoi_gian_bat_dau_dong_bhxh) > new Date(thoi_gian_ket_thuc_dong_bhxh))
      {
        return 'add_document_moha.social_insurance_start_date_must_be_before_end_date'
      }
    }
    if(this.contractMohaUpdateFields && this.contractMohaUpdateFields.length){
      const today = this.toDateOnly(new Date());
      let nndh_bat_dau = this.getValueUpdateByCode(EnumCriteriaCode.nndh_bat_dau)
      let nndh_ket_thuc = this.getValueUpdateByCode(EnumCriteriaCode.nndh_ket_thuc)

      let ngay_bat_dau_hdld = this.getValueUpdateByCode(EnumCriteriaCode.ngay_bat_dau_hdld)
      let ngay_ket_thuc_hdld = this.getValueUpdateByCode(EnumCriteriaCode.ngay_ket_thuc_hdld)

      let thoi_gian_bat_dau_dong_bhxh = this.getValueUpdateByCode(EnumCriteriaCode.thoi_gian_bat_dau_dong_bhxh)
      let thoi_gian_ket_thuc_dong_bhxh = this.getValueUpdateByCode(EnumCriteriaCode.thoi_gian_ket_thuc_dong_bhxh)
      let ngay_ap_dung_dia_diem_moi = this.getValueUpdateByCode(EnumCriteriaCode.ngay_ap_dung_dia_diem_moi)
      let ngay_ket_thuc_hop_dong_moi = this.getValueUpdateByCode(EnumCriteriaCode.ngay_ket_thuc_hop_dong_moi)
      let ngay_cham_dut_hop_dong = this.getValueUpdateByCode(EnumCriteriaCode.ngay_cham_dut_hop_dong)

      if(nndh_bat_dau && nndh_ket_thuc &&
        new Date(nndh_bat_dau) > new Date(nndh_ket_thuc))
      {
        return 'add_document_moha.hazardous_job_start_date_must_be_before_end_date'
      }

      if(ngay_bat_dau_hdld && ngay_ket_thuc_hdld &&
        new Date(ngay_bat_dau_hdld) > new Date(ngay_ket_thuc_hdld))
      {
        return 'add_document_moha.expiration_date_must_be_on_or_after_effective_date'
      }

      if(thoi_gian_bat_dau_dong_bhxh && thoi_gian_ket_thuc_dong_bhxh &&
        new Date(thoi_gian_bat_dau_dong_bhxh) > new Date(thoi_gian_ket_thuc_dong_bhxh))
      {
        return 'add_document_moha.social_insurance_start_date_must_be_before_end_date'
      }
     if (
        ngay_ap_dung_dia_diem_moi &&
        this.toDateOnly(ngay_ap_dung_dia_diem_moi) < today
      ) {
        return 'add_document_moha.the_effective_date_of_the_new_location';
      }

      if (
        ngay_ket_thuc_hop_dong_moi &&
        this.toDateOnly(ngay_ket_thuc_hop_dong_moi) < today
      ) {
        return 'add_document_moha.the_contract_end_date_must_be';
      }

      if (
        ngay_cham_dut_hop_dong &&
        this.toDateOnly(ngay_cham_dut_hop_dong) < today
      ) {
        return 'add_document_moha.the_contract_termination_date_must_be';
      }
    }
  }

  getValueByCode(code: any){
    return this.contractMohaFields.find((field: any) => field.key == code) ? this.contractMohaFields.find((field: any) => field.key == code).value : null
  }
  getValueUpdateByCode(code: any){
    return this.contractMohaUpdateFields.find((field: any) => field.key == code) ? this.contractMohaUpdateFields.find((field: any) => field.key == code).value : null
  }

  convertTitleContent(type: string) {
    let title: string = '';
    switch (type) {
      case this.enumAdjustedContents.THAY_DOI_MUC_LUONG_PHU_CAP:
        title = this.message.getMessage('add_document_moha.adjusted_contents.salary_change')
        break;
      case this.enumAdjustedContents.GIA_HAN_HOP_DONG:
        title = this.message.getMessage('add_document_moha.adjusted_contents.contract_renewal')
        break;
      case this.enumAdjustedContents.CHAM_DUT_HOP_DONG:
        title = this.message.getMessage('add_document_moha.adjusted_contents.contract_termination')
        break;
      case this.enumAdjustedContents.THAY_DOI_VI_TRI_LAM_VIEC_DIA_DIEM:
        title = this.message.getMessage('add_document_moha.adjusted_contents.job_position_change')
        break;
      default:
        title = this.message.getMessage('add_document_moha.adjusted_contents.social_insurance_information_update')
        break;
    }
    return title
  }
}
